/*=========================================================================================
  File Name: moduleAdminMutations.js
  Description: Admin Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

    SET_SERVER_MONITORING_EMAIL(state, data){
        state.serverMonitoringEmail = data.resultBody
        state.serverMonitoringEmailCount = data.resultCount
    },
    SET_SERVER_MONITORING_LIMIT(state, data){
      state.serverMonitoringLimit = data.resultBody
    },
    SET_APP_VERSION(state,data){
      for(let app in data.resultBody){
        if(data.resultBody[app].mobileCode == 1){
          state.androidAppVersion = data.resultBody[app].appVersion
        } else{
          state.iosAppVersion = data.resultBody[app].appVersion
        }
      }
    },
    SET_FIRMWARE_VERSION(state,data){
      state.dvrsFirmwareSeq = data.resultBody.seq
      state.dvrsFirmwareVersion = data.resultBody.firmwareVersion
    },
    SET_UPDATE_VERSION_HISTORY(state, data){
      state.versionUpdateHistory = data.resultBody
      state.versionUpdateHisotyCount = data.resultCount
    },
    SET_NOTICE(state, data){
      state.notice = data.resultBody
      state.noticeCount = data.resultCount
    },
    SET_SERVER_LIST(state, data){
      state.serverList = data.resultBody
    },
    SET_SERVER_MONITORING(state, data){
      let monitoringHistory = data.resultBody
      state.avgCpuSeries=[]
      state.maxCpuSeries=[]
      state.avgMemorySeries=[]
      state.maxMemorySeries=[]
      state.avgIoSeries=[]
      state.maxIoSeries=[]
      state.avgDiskSeries=[]
      state.maxDiskSeries=[]
      state.avgNRxSeries=[]
      state.maxNRxSeries=[]
      state.avgNTxSeries=[]
      state.maxNTxSeries=[]

      for(let item in monitoringHistory){
        
        let eventDate = monitoringHistory[item].eventDate

        state.avgCpuSeries[item]=  {
          x:eventDate,
          y:monitoringHistory[item].avgCpu
        }

        state.maxCpuSeries[item] =  {
          x: eventDate,
          y: monitoringHistory[item].maxCpu
        }

        state.avgMemorySeries[item] = {
          x: eventDate,
          y: monitoringHistory[item].avgMemory
        }

        state.maxMemorySeries[item] = {
          x: eventDate,
          y: monitoringHistory[item].maxMemory
        }

        state.avgIoSeries[item] = {
          x: eventDate,
          y: monitoringHistory[item].avgIo
        }

        state.maxIoSeries[item] = {
          x: eventDate,
          y: monitoringHistory[item].maxIo
        }

        state.avgDiskSeries[item] =  {
          x: eventDate,
          y: monitoringHistory[item].avgDisk
        }

        state.maxDiskSeries[item] = {
          x: eventDate,
          y: monitoringHistory[item].maxDisk
        }

        state.avgNRxSeries[item] = {
          x: eventDate,
          y: monitoringHistory[item].avgNRx
        }

        state.maxNRxSeries[item] =  {
          x: eventDate,
          y: monitoringHistory[item].maxNRx
        }

        state.avgNTxSeries[item] = {
          x: eventDate,
          y: monitoringHistory[item].avgNTx
        }

        state.maxNTxSeries[item] = {
          x: eventDate,
          y: monitoringHistory[item].maxNTx
        }

      }

    },
    SET_NOTI_EMAIL(state, data){
      state.notiEmail = data.resultBody
      state.notiEmailCount = data.resultCount
    },
      
}